import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Tailwind
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { installApiAuthFetch } from './utils/apiAuthFetch';

// Injecte initData / pwaToken / deviceId sur tous les fetch API (signet inclus)
installApiAuthFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
